import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { Device } from "utils/device";
import { CL, CM } from "components/Typography";
import { colours } from "utils";
import MarketingLink from "../../MarketingLink";

const author = "Daisy Beck, Accelerate Learner";
const source = "Learner Testimonial";
const linkText = "Enquire now";

const AccelerateLearnerQuote: FunctionComponent = () => {
  return (
    <>
      <S.Section>
        <S.Copy>
          <b>
            “The Accelerate Programme was brilliant. Building a network with
            other like-minded women is invaluable and AllBright really supported
            this.{" "}
          </b>
          In addition to the bi-weekly zoom calls, you have access to 24/7
          training material including podcasts, videos, and a workbooks – the
          learning and resources available are never ending. Each session you
          come away feeling empowered, confident and having learnt a little
          something about yourself.”
        </S.Copy>
        <S.Author>{author}</S.Author>
        <S.Source>{source}</S.Source>
        <MarketingLink
          href="/accelerate"
          colour={colours.marketingNavy}
          linkText={linkText}
        />
      </S.Section>
      <S.Decoration />
    </>
  );
};

const S = () => {};

S.Section = styled.section`
  width: 100%;
  padding: 10%;
  display: flex;
  flex-direction: column;
  background: ${colours.marketingOrange};
  color: ${colours.marketingNavy};

  @media (min-width: ${Device.mobile}) {
    padding: 10% 30% 8% 10%;
  }

  /* @media(min-width: ${Device.tablet}) {
    padding: 10% 30% 8% 10%;
  } */

  @media (min-width: ${Device.desktop}) {
    padding: 8% 30% 6% 10%;
  }
`;

S.Copy = styled.p`
  font-size: 1.5rem;
  padding-bottom: 2rem;

  @media (min-width: ${Device.mobile}) {
    font-size: 2rem;
  }

  @media (min-width: ${Device.tablet}) {
    font-size: 2.5rem;
    padding-bottom: 4rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 3.5rem;
    padding-bottom: 6rem;
  }
`;
S.Author = styled(CM)`
  font-weight: 800;

  @media (min-width: ${Device.mobile}) {
    font-size: 2rem;
  }

  @media (min-width: ${Device.tablet}) {
    font-size: 2.5rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 3rem;
  }
`;

S.Source = styled(CL)`
  padding-bottom: 2rem;

  @media (min-width: ${Device.tablet}) {
    padding-bottom: 4rem;
  }

  @media (min-width: ${Device.desktop}) {
    padding-bottom: 6rem;
  }
`;

S.Decoration = styled.div`
  height: 70px;
  background-image: url("/images/marketing/peach-tessellation.svg");
  background-size: 400% auto;
  background-position: bottom;

  @media (min-width: ${Device.mobile}) {
    height: 80px;
    background-size: 300% auto;
  }

  @media (min-width: ${Device.tablet}) {
    height: 100px;
    background-size: 200% auto;
  }

  @media (min-width: ${Device.desktop}) {
    background-size: 100% auto;
  }
`;

export default AccelerateLearnerQuote;
